import { downloadFileByUrl } from 'legacy/lut/helpers/files/downloadFileByUrl'

import { calculateFileLink } from 'core/classes/helpers/saveFiles'

import { IFinancialCockpitEltDocument } from '../../../api/types'

export const downloadEltDocumentPptx = (document: IFinancialCockpitEltDocument): void => {
  const link = calculateFileLink({
    formId: 1233,
    fieldName: 'PPTXReport',
    UID: document.UID,
    fileName: document.PPTXReport,
    entryId: document.EntryId,
  })

  downloadFileByUrl(link, 'elt-form')
}
